export const MANUFACTURING_RST_SERVICE_NAMES = [
  'Manufacturing Services',
  'Specialized Fabrication and Welding',
] as const;

export type RevenueServiceTypeOption = {
  id: string;
  service_code?: string;
  service_name?: string;
};

function normalizeName(value: string | null | undefined): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function isManufacturingRevenueServiceName(serviceName: string | null | undefined): boolean {
  const n = normalizeName(serviceName);
  if (!n) return false;
  return MANUFACTURING_RST_SERVICE_NAMES.some((label) => normalizeName(label) === n);
}

export function isManufacturingRevenueServiceType(
  rst: RevenueServiceTypeOption | null | undefined
): boolean {
  if (!rst) return false;
  if (isManufacturingRevenueServiceName(rst.service_name)) return true;
  const code = String(rst.service_code ?? '')
    .trim()
    .toUpperCase();
  return code === 'MS' || code === 'SFW';
}

export function isIndustrialTradingRevenueServiceType(
  rst: RevenueServiceTypeOption | null | undefined
): boolean {
  if (!rst) return false;
  return normalizeName(rst.service_name) === normalizeName('Industrial Trading');
}

export function resolveRstFromList(
  revenueServiceTypeId: string | null | undefined,
  types: RevenueServiceTypeOption[]
): RevenueServiceTypeOption | null {
  if (!revenueServiceTypeId?.trim()) return null;
  return types.find((t) => t.id === revenueServiceTypeId.trim()) ?? null;
}
